import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FamilyAuthLayout, {
  FIELD,
  FormError,
  HEADING,
  QUIET_LINK,
} from "../../components/family/FamilyAuthLayout";

const API = process.env.REACT_APP_API_URL;

export default function FamilyLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API}/me`, { credentials: "include" });
        if (!alive || !res.ok) return;
        const data = await res.json();
        if (data?.role === "family_member") navigate("/family", { replace: true });
        else navigate("/übersicht", { replace: true });
      } catch {
        // ignore
      }
    })();
    return () => {
      alive = false;
    };
  }, [navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/family/login`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.message || "Login fehlgeschlagen.");
      navigate("/family", { replace: true });
    } catch (error) {
      setErr(error?.message || "Login fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <FamilyAuthLayout documentTitle="Anmelden · SteffiCare">
      <h1 className={HEADING}>Willkommen zurück</h1>

      <form onSubmit={handleSubmit} className="mt-8 flex flex-col gap-3 text-left">
        <input
          required
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="E-Mail-Adresse"
          autoComplete="email"
          className={FIELD}
        />
        <input
          required
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          placeholder="Passwort"
          autoComplete="current-password"
          className={FIELD}
        />

        {err ? <FormError>{err}</FormError> : null}

        <button type="submit" disabled={loading} className="btn btn-primary mt-2 w-full justify-center">
          {loading ? "Wird angemeldet …" : "Anmelden"}
        </button>
      </form>

      <p className="mt-8 text-base leading-snug text-[color:var(--ink-3)]">
        Noch kein Konto? Dafür brauchst du einen Einladungslink.
      </p>
      <div className="mt-3">
        <Link to="/login" className={QUIET_LINK}>
          Zum Pflege-Login
        </Link>
      </div>
    </FamilyAuthLayout>
  );
}
